module.exports = __webpack_public_path__ + "03_short_gold.46083d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_short_gold.png
// module id = 0RpM
// module chunks = 0